export function getCountryFlagEmoji(countryCode: string): string {
  const code = countryCode.toUpperCase();
  if (code.length !== 2) return "";
  return String.fromCodePoint(
    ...[...code].map((char) => 0x1f1a5 + char.charCodeAt(0)),
  );
}

export function getCountryName(
  countryCode: string | null | undefined,
): string | null {
  if (!countryCode) return null;
  try {
    const names = new Intl.DisplayNames(["en"], { type: "region" });
    return names.of(countryCode.toUpperCase()) ?? null;
  } catch {
    return null;
  }
}

/**
 * Request a server-resized Shopify CDN image by appending ?width=N.
 * Non-Shopify URLs and already-parameterized URLs are returned as-is.
 */
export function optimizeShopifyImage(
  url: string | undefined | null,
  width: number,
): string {
  if (!url) return "";
  if (!url.includes("cdn.shopify.com")) return url;
  if (url.includes("width=")) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}width=${width}`;
}

export function formatRelativeTime(isoDate: string): string {
  const date = new Date(isoDate);
  const now = new Date();
  const seconds = Math.max(0, Math.floor((now.getTime() - date.getTime()) / 1000));

  if (seconds < 60) return "just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.floor(months / 12)}y ago`;
}
